import { onLCP, onINP, onCLS, onFCP, onTTFB } from 'web-vitals/attribution';
import type { MetricWithAttribution } from 'web-vitals/attribution';
import { trackEvent } from '@/lib/datadog';

function send(metric: MetricWithAttribution) {
  trackEvent(`web_vital.${metric.name.toLowerCase()}`, {
    category: 'web_vital',
    value: metric.value,
    rating: metric.rating,
    attribution: metric.attribution,
    route: globalThis.location.pathname,
  });
}

export function initWebVitals(): void {
  onLCP(send);
  onINP(send);
  onCLS(send);
  onFCP(send);
  onTTFB(send);
}
